import styled from '@emotion/styled';
import { Color } from '../../../../styles/Color';
import { Z_INDEX_NAVIGATION_MENU } from '../../../../styles/zIndex';
import { Css } from '../../../../ui';
import { getIconStrokeStyles } from '../../../../styles/getIconStrokeStyles';

export const ToggleButton = styled.button`
	height: ${Css.pxToRem(48)};
	pointer-events: all;
	display: flex;
	align-items: center;
	gap: ${Css.pxToRem(8)};

	padding: ${Css.pxToRem(12)} ${Css.pxToRem(16)};
	float: right;
	z-index: ${Z_INDEX_NAVIGATION_MENU};

	color: ${Color.PrimaryWhite};
	background: ${Color.HeaderButtonBackground};
	border: none;
	border-radius: 56px;

	${getIconStrokeStyles()}
`;
